<!--
 * @Author: mazhenjie mazhenjie@soidentify.com
 * @Date: 2025-04-01 19:25:47
 * @LastEditors: mazhenjie mazhenjie@soidentify.com
 * @LastEditTime: 2025-04-14 19:47:05
 * @FilePath: /dingjian-web/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {},
};
</script>

<style>
body,
html,
#app {
  height: 100%;
  width: 100%;
  margin: 0;
  /*overflow: hidden;*/
  -webkit-overflow-scrolling: touch;
  min-width: 1200px;
}
* {
  margin: 0;
  padding: 0;
  font-family: pingfang sc;
}
html,
body {
  height: 100%;
}
.content {
  width: 1400px;
  margin: 0 auto;
}
.fl {
  clear: both;
}
.ov {
  overflow: hidden;
}
</style>
